import AddMethodPage from "./AddMethodPage";

export default AddMethodPage;
